
import Vue from 'vue';

import * as CorpusStore from '@/store/search/corpus';
import { NormalizedAnnotation, NormalizedMetadataField } from '@/types/apptypes';
import { BLDocFields } from '@/types/blacklabtypes';

import HitsTable from '@/pages/search/results/table/HitsTable.vue';
import DocRow, {DocRowData} from '@/pages/search/results/table/DocRow.vue';
import { snippetParts } from '@/utils/hit-highlighting';

import { HitRowData } from '@/pages/search/results/table/HitRow.vue';
export { DocRowData } from '@/pages/search/results/table/DocRow.vue';

export default Vue.extend({
	components: {HitsTable, DocRow},
	props: {
		mainAnnotation: Object as () => NormalizedAnnotation,
		metadata: Array as () => NormalizedMetadataField[]|undefined,
		dir: String as () => 'ltr'|'rtl',
		html: Boolean,
		disabled: Boolean,

		showHits: Boolean,

		data: Array as () => DocRowData[]
	},
	computed: {
		hasHits(): boolean { return this.data[0]?.doc.numberOfHits != null; },
		specialFields(): BLDocFields { return CorpusStore.getState().corpus!.fieldInfo; },
	},
	methods: {
		changeSort(sort: string) {
			this.$emit('changeSort', sort)
		},
		hitRowsForDoc(docRow: DocRowData): HitRowData[] {
			return docRow.doc.snippets!.map<HitRowData>(s => ({
				hit: s,
				annotatedField: undefined,
				href: '',
				isForeign: false,
				// Don't pass color info here. We don't show capture highlights or releation info in doc snippets.
				context: snippetParts(s, this.mainAnnotation.id, this.dir),
				doc: docRow.doc,
				gloss_fields: [],
				hit_first_word_id: '',
				hit_id: '',
				hit_last_word_id: '',
			}))
		},
		hiddenHits(docRow: DocRowData): number {
			return (docRow.doc.numberOfHits || 0) - (docRow.doc.snippets?.length || 0);
		}
	}

})
